import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Components/css/Navbar.css";

const products = [
  {
    id: "edi-converter",
    category: "Products",
    subcategories: [
      {
        id: "edi-converter-link",
        name: "Antrazal EDI Converter",
        path: "/products/edi-converter",
      },
    ],
  },
];

export default function ProductDropdown({ handleState }) {
  const [isdropdownState, setIsdropdownState] = useState(false);
  const [windowDimension, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const location = useLocation();
  const isWhiteBg =
    location.pathname.includes("/customer-stories/") ||
    location.pathname.includes("/services/") ||
    location.pathname.includes("/products/") ||
    location.pathname.includes("/edi-converter") ||
    location.pathname.includes("/careers") ||
    location.pathname.includes("/events") ||
    location.pathname.includes("/case-studies");

  const detectSize = () => {
    detectHW({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => window.removeEventListener("resize", detectSize);
  }, [windowDimension]);

  const handleDropdown = () => {
    setIsdropdownState((current) => !current);
  };

  const handleProductClick = () => {
    setIsdropdownState(false);
    if (handleState) {
      handleState();
    }
  };

  const isMobile = windowDimension.winWidth < 1118;

  return (
    <li className={isdropdownState ? "dropdown__item show-dropdown" : "dropdown__item"}>
      <div
        className={`nav__link dropdown__button ${isWhiteBg ? "nav-list-white" : "nav-list-transparent"}`}
        onClick={handleDropdown}
      >
        Products
        <i className="ri-arrow-down-s-line dropdown__arrow"></i>
      </div>

      <div
        className={
          isdropdownState
            ? "dropdown__container height_dropdown"
            : "dropdown__container dropdown__container2"
        }
        style={{ backgroundColor: "#fff" }}
      >
        {isMobile ? (
          <div style={{ backgroundColor: "#fff", padding: "0.15rem 0 0.5rem" }}>
            {products.flatMap((product) => product.subcategories).map((sub) => (
              <Link
                key={sub.id}
                rel="canonical"
                to={sub.path}
                onClick={handleProductClick}
                style={{
                  display: "block",
                  padding: "0.65rem 1.5rem 0.65rem 2.5rem",
                  fontSize: "0.9rem",
                  color: "#222",
                  textDecoration: "none",
                  borderBottom: "1px solid #eef0f5",
                }}
              >
                {sub.name}
              </Link>
            ))}
          </div>
        ) : (
          <div
            className="dropdown__content"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gridTemplateRows: "repeat(1, 1fr)",
              gap: "1.5rem 2rem",
              padding: "1.5rem",
            }}
          >
            {products.map((product) => (
              <div
                key={product.id}
                className="dropdown__group"
                style={{ flexDirection: "column", gap: "0rem" }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.4rem" }}>
                  <h3
                    className="dropdown__title"
                    style={{
                      fontSize: "0.9rem",
                      marginBottom: "0",
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {product.category}
                  </h3>
                </div>
                <div
                  style={{
                    height: "1px",
                    background: "linear-gradient(to right, #2C58ED, #9B1EA4)",
                    borderRadius: "2px",
                    marginBottom: "0.5rem",
                  }}
                ></div>

                <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                  {product.subcategories.map((sub) => (
                    <Link
                      key={sub.id}
                      rel="canonical"
                      to={sub.path}
                      onClick={handleProductClick}
                      className="dropdown__link hover-underline"
                      style={{
                        fontSize: "0.82rem",
                        color: "#555",
                        textDecoration: "none",
                        padding: "3px 4px",
                        borderRadius: "4px",
                        transition: "background 0.2s, color 0.2s",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      {sub.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </li>
  );
}
